import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import App from "./components/App";
import * as serviceWorker from "./serviceWorker";

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//RW1haWw6IGRhbmllbG1nZWhyaWdAaG90bWFpbC5jb20gUGFzc3dvcmQ6IEhhbnVzYW51czI=
serviceWorker.unregister();
